var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "chatWindow", attrs: { id: "chat-window-wrapper" } },
    [
      _c("Chat", {
        ref: "chat",
        attrs: {
          contact: _vm.contact,
          messageSyncRunning: _vm.messageSyncRunning,
          messages: _vm.getMessages(),
          visitorTypingMessage: _vm.visitorTypingMessage,
          "is-live": _vm.isLive,
          showHeader: _vm.showHeader,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }